import { render, staticRenderFns } from "./ConfirmGradeTeacher.vue?vue&type=template&id=5ea0f482&scoped=true"
import script from "./ConfirmGradeTeacher.vue?vue&type=script&lang=js"
export * from "./ConfirmGradeTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea0f482",
  null
  
)

export default component.exports